import React, { Component } from "react";
import { Header } from './modules/HeaderContent';
import { Footer } from './modules/FooterContent';
import Title from "../components/modules/Title";
import BreadCrumb from "../components/modules/BreadCrumb";
import NeedMoreSupport from "../components/modules/NeedMoreSupport";
import {Accordion, AccordionHeader, AccordionTitle, AccordionSubTitle, AccordionDetail, AccordionItem} from '@vds/accordions';
// import AccordionOld from "../components/modules/Accordion";
import ReactHtmlParser from 'react-html-parser';
import StatusBanner from "./modules/StatusBanner";
import SignIn from "../components/modules/Signin";
import { Chat } from "./modules/IncludeChat";
import { CMS_LOCATION, MAIN_SERVER, SIT_SERVER } from "../constants/constants";
import "../assets/css/batterybackup.css";
import "../assets/css/batteryoutage.css";
import BatteryDetails from "./BatteryDetails";
import { RTCICall } from "./modules/RTCICall";
import ErrorBoundary from './modules/ErrorHandler';
import { SiteCatalyst } from '../components/modules/SiteCatalyst';
import { isNullOrUndefined, RemoveHeaderHiddenClass, checkUrlPath } from "./modules/CommonFunctions";
import AlertBanner from './modules/AlertBanner';
//DE322-613 - reviewed
export default class BatteryBackup extends Component {
  componentDidMount() {
    let args = {
      intentCategory: "NBA_DISPLAY",
      activityCategory: "NBA_DISPLAY",
      intent: "",
      app_n_channel: "NBA-ESUPPORT",
      os: ""
    };
    //RTCICall(args);
    RemoveHeaderHiddenClass();
    Chat();
    // setTimeout(() => {
    // 	document.querySelector('.vzw-header').classList.remove('vzw-header');
    // }, 1000);
  }

  getLearnMoreURL(index) {
    let url =
      index === 0
        ? "/support/consumer/battery-backup/power-reserve"
        : index === 1
        ? "/support/consumer/battery-backup/backup-unit"
        : "/support/consumer/battery-backup/storage-unit";
    return url;
  }

  openSignInPage() {
    // let currentLocation = window.location.href;
    // let url = currentLocation.indexOf("sit") > -1 ? SIT_SERVER : MAIN_SERVER;
    // window.location.href =
    //   url +
    //   "home/myverizon/?goto=" +
    //   window.encodeURIComponent(currentLocation);
    let currentLocation = window.location.href;
    let url = currentLocation.indexOf("sit") > -1 ? SIT_SERVER : MAIN_SERVER;
  
      if(currentLocation.indexOf("sit") > -1){
        window.location.href ="https://securesit1.verizon.com/signin?goto=" + 
        window.encodeURIComponent(currentLocation);
      }
      else if(currentLocation.indexOf("www98") > -1){
        window.location.href ="https://secure.verizon.com/signin?goto=" + 
        window.encodeURIComponent(currentLocation);
      }else{
        window.location.href ="https://secure.verizon.com/signin?goto=" + 
        window.encodeURIComponent(currentLocation);
      }
  }

  render() {
    document.body.classList.add("battery_backup");
    let renderSignInPage = true;
    let isSignInUser = document.cookie.indexOf("userinfo") > -1 ? true : false;
    if (isSignInUser && this.props.BBUPageJSON.bbulist === undefined) {
      isSignInUser = false;
      renderSignInPage = false;
    } else if (isSignInUser) {
      renderSignInPage = false;
    }
    if (!isSignInUser) {
      /* To check the outages for signin user  */
      return (
        <React.Fragment>
          <ErrorBoundary>
            <Header/>
          </ErrorBoundary>
          <main role="main">
            <ErrorBoundary>
            <SignIn
              CallBack={this.openSignInPage.bind(this)}
              isSignIn={renderSignInPage}
            />
            </ErrorBoundary>
            <ErrorBoundary>
            <BreadCrumb Content1="Support" Content2="Battery Backup" />
            </ErrorBoundary>
            <ErrorBoundary>
              <div className="row">
                <AlertBanner
                  AlertBannerData={this.props.AlertBanner}
                  isBreadCrumb={true}
                />
              </div>
            </ErrorBoundary>
            <ErrorBoundary>
            <Title
              Header={this.props.BBUPageJSON.titledesc[0].title}
              Content={this.props.BBUPageJSON.titledesc[0].richText2}
            />
            </ErrorBoundary>
            <div className="cmb-container margin-bottom-xlarge unit-area">
              <div className="row">
                <div className="columns tiny-12">
                  <h2
                    className={
                      this.props.BBUPageJSON.titledesc[1] !== undefined
                        ? "h5 margin-top-xlarge"
                        : "h5 margin-top-xlarge hide"
                    }
                  >
                    {this.props.BBUPageJSON.titledesc[1] !== undefined
                      ? this.props.BBUPageJSON.titledesc[1].title
                      : ""}
                  </h2>
                  <div className="custom-columns margin-bottom-medium">
                    <div className="flex-row" key="units">
                      {this.props.BBUPageJSON.collist.map((item, index) => {
                        return (
                          <div className="column padding-all-tiny padding-top-medium flex-column border-none medium-4 tiny-12 unit-section">
                            <div className="medium-p-100 thin-line" />
                            <img
                              alt=" " tabIndex="-1" aria-hidden="true"
                              className="margin-bottom-medium margin-top-medium center image-section"
                              src={
                                CMS_LOCATION + item.imagelist[0].fileReference
                              }
                            />
                            <h3 className="h6 margin-top-zero margin-bottom-zero">
                              {item.titleDescription[0].title}
                            </h3>
                            <div className="bottom">
                              <p className="margin-bottom-zero bold">
                                <a
                                  className="button cta-text mw-large userag arrow-button"
                                  href={checkUrlPath(this.getLearnMoreURL(index))}
                                  role="button"
                                  tabIndex="0"
                                  data-track="Learn more"
                                  role="link"
                                  aria-label={"Learn more "+item.titleDescription[0].title}
                                >
                                  Learn more
                                </a>
                              </p>
                            </div>
                          </div>
                        );
                      })}
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <ErrorBoundary>
            <div class="row">
                <div class="tiny-12">
                    <div className="accordian-wrap">
                        <Accordion>
                            {this.props.BBUPageJSON.titledesc[2] !== undefined
                  && ReactHtmlParser(this.props.BBUPageJSON.titledesc[2].richText2)}
                            {this.props.BBUPageJSON.accordions[0].accordionList.map(item => (
                                item.accordionrte && <AccordionItem>
                                <AccordionHeader 
                                triggerType="icon"
                                >      <AccordionTitle><span className="accordian-title">{item.accordianHeading}</span></AccordionTitle>
                                </AccordionHeader>
                                <AccordionDetail>
                                {ReactHtmlParser(item.accordionrte)}
                                </AccordionDetail>
                            </AccordionItem>))}
                        </Accordion>
                    </div>
                </div>
            </div>
            {/* <AccordionOld
              DataSource={this.props.BBUPageJSON.accordions[0].accordionList}
              Header={
                this.props.BBUPageJSON.titledesc[2] !== undefined
                  ? this.props.BBUPageJSON.titledesc[2].richText2
                  : ""
              }
            /> */}
            </ErrorBoundary>
            <ErrorBoundary>
            <NeedMoreSupport Data={this.props.BBUPageJSON} />
            </ErrorBoundary>
          </main>
          <ErrorBoundary>
            <Footer/>
          </ErrorBoundary>
          <input type="hidden" value={(isSignInUser) ? "Auth" : "UnAuth"} id="loginType"/>
          <ErrorBoundary>
              <SiteCatalyst PageDetails={this.props.BBUPageJSON.pagedetails}/>
          </ErrorBoundary> 
        </React.Fragment>
      );
    } else {
      return (
        <React.Fragment>
          <ErrorBoundary>
            <Header/>
          </ErrorBoundary>
          <main role="main">
            <ErrorBoundary>
            <BreadCrumb Content1="Support" Content2="Battery Backup" />
            </ErrorBoundary>
            <ErrorBoundary>
            <ErrorBoundary>
              <div className="row">
                <AlertBanner
                  AlertBannerData={this.props.AlertBanner}
                  isBreadCrumb={true}
                />
              </div>
            </ErrorBoundary>
            <Title
              Header={this.props.BBUPageJSON.titledesc[0].title}
              Content={this.props.BBUPageJSON.titledesc[0].richText2}
            />
            </ErrorBoundary>
            <ErrorBoundary>
            <BatteryDetails />
            </ErrorBoundary>
            <ErrorBoundary>
            <StatusBanner
              Status1={this.props.BBUPageJSON.bbulist[0].statuheader}
              Status2={this.props.BBUPageJSON.bbulist[0].statustext}
              Linktext={this.props.BBUPageJSON.bbulist[0].linktext}
              Linkurl={this.props.BBUPageJSON.bbulist[0].linkredirection}
              ImageUrl={this.props.BBUPageJSON.bbulist[0].bbustatusImage}
              Logo="./shipping.png"
            />
            </ErrorBoundary>
            <ErrorBoundary>
            <div class="row">
                <div class="tiny-12">
                    <div className="accordian-wrap">
                        <Accordion>
                            {this.props.BBUPageJSON.titledesc[2] !== undefined
                  && ReactHtmlParser(this.props.BBUPageJSON.titledesc[2].richText2)}
                            {this.props.BBUPageJSON.accordions[0].accordionList.map(item => (
                                item.accordionrte && <AccordionItem>
                                <AccordionHeader 
                                triggerType="icon"
                                >      <AccordionTitle><span className="accordian-title">{item.accordianHeading}</span></AccordionTitle>
                                </AccordionHeader>
                                <AccordionDetail>
                                  <div>
                                  {ReactHtmlParser(item.accordionrte)}
                                </div>
                                </AccordionDetail>
                            </AccordionItem>))}
                        </Accordion>
                    </div>
                </div>
            </div>
            {/* <AccordionOld
              DataSource={this.props.BBUPageJSON.accordions[0].accordionList}
              Header={
                this.props.BBUPageJSON.titledesc[2] !== undefined
                  ? this.props.BBUPageJSON.titledesc[2].richText2
                  : ""
              }
            /> */}
            </ErrorBoundary>
            <ErrorBoundary>
            <NeedMoreSupport Data={this.props.BBUPageJSON} />
            </ErrorBoundary>
          </main>
          <ErrorBoundary>
            <Footer/>
          </ErrorBoundary>
          <input type="hidden" value={(isSignInUser) ? "Auth" : "UnAuth"} id="loginType"/>
          <ErrorBoundary>
              <SiteCatalyst PageDetails={this.props.BBUPageJSON.pagedetails}/>
          </ErrorBoundary> 
        </React.Fragment>
      );
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/BatteryBackupPage.js